export default {
  primary: {
    base: "#ba8302",
  },
  secondary: {
    base: "#ba5502",
  },
  error: {
    base: "#f44336",
  },
  warning: {
    base: "#ffd703",
  },
  info: {
    base: "#03A9F4",
  },
  success: {
    base: "#4caf50",
  },
  pending: {
    base: "#8a8a8a",
  },
  darkGrey: {
    base: "1E1E1E",
  },
  deepBlack: {
    base: "#000000",
  },
  text: {
    base: "#ffffff",
  },
  background: {
    // base: "#20272E",
    base: "#000000",
  },
  anchor: {
    base: "#ffffff",
  },
};
